<template>
    <section class="content">
    <div class="flex justify-content-center">
    <div class="overlay-wrapper">
        <div class="w-100 card">
        <div class="overlay" v-if="loadingContent"><h1 style="font-size:40px;">Sedang diproses <i class="fas fa-sync-alt fa-spin"></i></h1></div>
        <div class="card-body">
            <div class="row">
            <div class="col-xl-12 d-flex justify-content-end mb-2">
                <div class="row form-horizontal justify-content-end">
                    <div class="col-auto col-xs-4">
                    <h4>Per Tanggal</h4>
                    </div>
                    <div class="col-md-4 col-xs-4">
                    <div class="input-group mb-3">
                        <input type="text" ref="daterange" class="form-control" style="border-right: 0"/>
                        <div class="input-group-append">
                        <div
                            class="input-group-text"
                            style="background-color: #fff">
                            <span><span class="fa fa-calendar"></span></span>
                        </div>
                        </div>
                    </div>
                    </div>
                    <div class="col-auto col-xs-4"></div>
                    <div class="col-auto col-xs-4">
                        <div class="btn-group" ref="toolbar">
                        <button type="button" data-action="read" class="btn btn-default" v-on:click="showTable">
                            <i class="fa fa-sync-alt"></i> Show Table
                        </button>
                        <button type="button" data-action="export-xlsx" class="btn btn-default" :disabled="loading" v-on:click="downloadXlsx"><i class="fa fa-download"></i> <span class="d-none d-md-inline-block">Download</span></button>
                        </div>
                    </div>
                </div>
            </div>
            </div>
            <div class="mb-2"></div>
            <div class="table-responsive" :hidden="hideTable">
                <table style="width:100%" class="table table-hover" ref="tblpiutang">
                <thead>
                    <tr>
                    <th>TANGGAL</th>
                    <th>COA</th>
                    <th>NO. JURNAL</th>
                    <th>REFERENSI</th>
                    <th>STATUS TERAKHIR</th>
                    <th>TANGGAL STATUS TERAKHIR</th>
                    <th>DURASI</th>
                    <th>DEBIT</th>
                    <th>KREDIT</th>
                    <th>SALDO</th>
                    </tr>
                </thead>
                <tbody @click="handleClick"></tbody>
                <tfoot>
                <tr>
                <th colspan="7"></th>
                <th></th>
                <th></th>
                <th></th>
                </tr>
                </tfoot>
                </table>
            </div>
        </div>
        </div>
    </div>
    </div>
    </section>
</template>
<script>
import { authFetch, createTable, formatCurrency } from "@/libs/hxcore";
import Swal from "sweetalert2";
import $ from "jquery";
import Daterangepicker from "daterangepicker";
import moment from "moment";
import "daterangepicker/daterangepicker.css";

export default {
    name: "Piutang",
    data() {
        return {
            dt1: "",
            dt2: "",
            dateStart: "",
            dateEnd: "",
            errors: [],
            method: "",
            jurnal: {
                coa_id: '',
                coa_no: '',
                coa_name: '',
            },
            roles: "",
            role_id: "",
            coa_id: "",
            filter: {},
            loading: false,
            loadingContent: false,
            hideTable: true
        };
    },
    created: function () {
        this.roles = this.$route.meta.roles;
        console.log("load initial data", this.$route);
        this.dateStart = moment().startOf("month").format("YYYY-MM-DD");
        this.filter.dt1 = this.dateStart;
    },
    methods: {
        onPeriode() {
            if (this.tablePiutang) {
                this.tablePiutang.api().ajax.reload();
            } else {
                // this.showTable();
            }
        },
        downloadXlsx: function (e) {
            const self = this;
            self.loading = true;
            self.loadingContent = true;
            
            var filter = JSON.parse(JSON.stringify(self.filter));
                filter.q = this.tablePiutang ? $("input[name=q]").val() : '';
                filter.category = this.tablePiutang ? $("select[name=category]").val() : 0;

            var data = Object.keys(filter)
            .map((key) =>
                encodeURIComponent(key) + "=" + encodeURIComponent(filter[key])
            ).join("&");

            authFetch("/report/piutang/excell", {
                method: "POST",
                body: data,
            })
            .then((response) => {
                if (response.status === 201) {
                } else if (response.status === 400) {
                } else if (response.status === 500){
                    Swal.fire("Timeout!", ``, "error");
                    this.loading = false;
                    this.loadingContent = false;
                    return false;
                }

                return response.blob();
            })
            .then((blob) => {
            setTimeout(() => {
                self.loading = false;
            }, 1000);
            self.loadingContent = false;
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement("a");
            a.href = url;
            a.download = "data.xlsx";
            document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
            a.click();
            a.remove(); //afterwards we remove the element again
            });
        },
        handleClick(e) {
            const er = this.$refs;
            if (e.target.matches(".link-role")) {
            }
        },
        showTable: function () {
            if (this.tablePiutang) {
                this.tablePiutang.api().ajax.reload();
            } else {
                this.hideTable = false;
                const e = this.$refs;
                var self = this;
                this.tablePiutang = createTable(e.tblpiutang, {
                    title: "",
                    ajax: "/report/piutang",
                    roles: this.$route.params.roles,
                    selectedRowClass: "",
                    toolbarEl: e.toolbar,
                    serverSide: true,
                    frame: false,
                    sort: false,
                    processing: true,
                    language: {
                        processing: '<i class="fa fa-spinner fa-5x fa-spin" style="font-size:50px;color:black;"></i>'},
                    lengthMenu: [[10, 25, 50, 100, 1000, -1], [ 10, 25, 50, 100, 1000, 'Semua' ]],
                    displayLength: 10,
                    lengthChange: true,
                    paramData: function (d) {
                        var filter = JSON.parse(JSON.stringify(self.filter));
                        for (const key in filter) {
                            d[key] = filter[key] === false ? 0: filter[key];
                        }
                    },
                    columns: [
                        { data: "journal_date", render: function (data, type, row, meta) {
                            return moment(data).format("DD/MM/YYYY");
                        }, },
                        { data: "coa_no",
                        render: function(data, type, row, meta) {
                            return `${data} (${row.coa_name})`;
                        } },
                        { data: "journal_no" },
                        { data: "referensi" },
                        { data: "status",
                        render: function (data, type, row, meta) {
                            if (row.cancel == 1)
                                return '<span class="badge badge-danger">Paket sudah dicancel</span>';
                            else if (row.pickupStatus == 0)
                                return '<span class="badge badge-inverse">DRAFT</span>';
                            else if (row.retClaim == 1)
                                return '<span class="badge badge-info">Paket sedang diclaim</span>';
                            else if (row.retClaim == 2)
                                return '<span class="badge badge-info">Paket claim disetujui</span>';
                            else if (row.retClaim == 3)
                                return '<span class="badge badge-info">Paket claim ditolak</span>';
                            else {
                                if (row.trackingStatus == 0)
                                    return '<span class="badge badge-secondary">Paket menunggu pickup</span>';
                                else if (row.trackingStatus == 1 && row.retClaim == 0)
                                    return '<span class="badge badge-warning">Paket on proses</span>';
                                else if (row.trackingStatus == 2 && row.retClaim == 0)
                                    if (row.status_cod > 0)
                                    return '<span class="badge badge-success">Terkirim - COD</span>';
                                    else
                                    return '<span class="badge badge-success">Terkirim - Non COD</span>';
                                else if (row.trackingStatus == 3 && row.retClaim == 0)
                                    return '<span class="badge badge-warning">Paket proses retur</span>';
                                else if (row.trackingStatus == 4 && row.retClaim == 0) {
                                    if (row.retStatus == 1) return '<span class="badge badge-info">Paket retur diterima</span>';
                                    else return '<span class="badge badge-info">Paket retur diserahkan</span>';
                                } else if (row.trackingStatus == 5 && row.retClaim == 0)
                                    return '<span class="badge badge-danger">Paket bermasalah</span>';
                            }
                        }, },
                        { data: "updated_on", render: function (data, type, row, meta) {
                            return moment(data).format("DD/MM/YYYY");
                        }, },
                        { data: "durasi",
                        render: function(data, type, row, meta) {
                            return `${data} hari`;
                        } },
                        { 
                        data: "sumdebit", 
                        class:'text-right',
                        render: function(data, type, row, meta) {
                            return formatCurrency(data);
                        }
                        },
                        { 
                        data: "sumcredit", 
                        class:'text-right',
                        render: function(data, type, row, meta) {
                            return formatCurrency(data);
                        }
                        },
                        { 
                        data: "sumtotal", 
                        class:'text-right',
                        render: function(data, type, row, meta) {
                            return formatCurrency(data);
                        }
                        },
                    ],
                    filterBy: [2,3],
                    rowCallback: function (row, data) {},
                    footerCallback:function ( row, data, start, end, display ){
                    var api = this.api(), data;
                        // Total over this page
                        var totaldebit;
                        totaldebit = 
                            api
                            .column(7)
                            .data()
                            .reduce( function (a, b) {
                                var x = parseFloat( a ) || 0;
                                var y = parseFloat( b ) || 0;
                                return x + y;
                            }, 0);

                        var totalcredit;
                        totalcredit = api
                            .column(8)
                            .data()
                            .reduce( function (a, b) {
                                var x = parseFloat( a ) || 0;
                                var y = parseFloat( b ) || 0;
                                return x + y;
                            }, 0 );

                        var totalsaldo;
                        totalsaldo = api
                            .column(9)
                            .data()
                            .reduce( function (a, b) {
                                var x = parseFloat( a ) || 0;
                                var y = parseFloat( b ) || 0;
                                return x + y;
                            }, 0 );

                        // Update footer
                            $( api.column(7).footer() ).html(
                                'Rp '+ formatCurrency(totaldebit)
                            );
                            $( api.column(8).footer() ).html(
                                'Rp '+ formatCurrency(totalcredit)
                            );
                            $( api.column(9).footer() ).html(
                                'Rp '+ formatCurrency(totalsaldo)
                            );
                    }
                });
            }
        }
    },
    mounted() {
    const e = this.$refs;
    const self = this;
    new Daterangepicker(this.$refs.daterange, {
        startDate: moment().startOf("month"),
        endDate: moment(),
        singleDatePicker: true,
        showDropdowns: true,
        locale: {
            format: 'DD/MM/YYYY'
        }
        }, function (d1, d2) {
        self.dateStart = d1.format("YYYY-MM-DD");
        self.dateEnd = d2.format("YYYY-MM-DD");
        self.filter.dt1 = self.dateStart;
        self.onPeriode();
        });
    $('.loading-overlay').removeClass('show');
    },
}
</script>